import Vue from 'vue'
import 'es6-promise/auto' // プロミスをポリフィルする
import App from './App'
import ErrorBoundary from './ErrorBoundary.vue' // エラーを捕捉するコンポーネント
import router from './router'
import store from './store' // Vuexのストアインスタンスをインポート
import Toasted from 'vue-toasted'
import session from './utils/session'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../plugins/font-awesome/css/font-awesome.min.css'
import 'vue-ionicons/ionicons.css'
import '../plugins/iCheck/all.css'
import '../plugins/datatables/dataTables.bootstrap4.css'
import '../lib/css/googleapis.css'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

Vue.prototype.$API_URL = window.API_URL
Vue.use(BootstrapVue)
Vue.use(Toasted)
Vue.config.productionTip = false
Vue.config.performance = true // NODE_ENV == 'development'で測定有効化

// ErrorBoundaryコンポーネントのインストール
Vue.component(ErrorBoundary.name, ErrorBoundary)

Vue.config.errorHandler = (err, vm, info) => {
  console.error('errorHandler err:', err)
  console.error('errorHandler vm:', vm)
  console.error('errorHandler info:', info)
}

Vue.filter('formatCurrency', function (input, format = '') {
  if (input !== null && input !== undefined) {
    if (input < 0) {
      return '-' + format + Math.abs(parseFloat(input)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    } else {
      return format + parseFloat(input).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  } else {
    return input
  }
})

Vue.mixin(session)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // インポートしたストアインスタンスを`store`オプションとして指定
  render: h => h(App)
})
